export default "__VITE_ASSET__JL7YvAJ8__"